module.exports = __webpack_public_path__ + "img/chevron-right.d7cdf786.svg";